import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'escapeHtml',
    standalone: false
})
export class EscapeHtmlPipe implements PipeTransform {

  transform(value: string): string {
    return this.escapeHtml(value);
  }

  escapeHtml(unsafe: string): string {
    return unsafe.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

}
